export const tippotH5 = {
  // 消息列表
  messages: "/api/msg/v1/messages",
};

//圣诞活动抽奖
export const kudasaiChristmas = {
  reward_list: "/api/p/v1/christmas/rewards",
  reward_claim: "/api/p/v1/christmas/lottery",
  reward_time: "/api/p/v1/christmas/info",
  props: "/api/p/v1/christmas/props",
};

//圣诞活动抽奖2
export const kudasaiChristmas2 = {
  reward_list: "/api/p/v1/christmas/rewards?value=2",
  reward_claim: "/api/p/v1/christmas/lottery?value=2",
  reward_time: "/api/p/v1/christmas/info?value=2",
  props: "/api/p/v1/christmas/props?value=2",
};

//储蓄罐
export const YuliActivity = {
  fragments: "/api/y/v1/activity/fragments",
  sprint_saving: "/api/y/v1/activity/sprint_saving",
  draw_arg: "/api/y/v1/activity/claim_sprint_saving",
  wallet_arg: "/api/y/v1/wallet",
  growth_config: "/api/y/v1/wallet/gr_preference",
  gr_fund_flow: "/api/y/v1/wallet/gr_fund_flow",
};

//周期活动
export const WeeklyActivity = {
  reward_list: "/api/p/v1/katharsis",
  reward_claim: "/api/p/v1/katharsis/reward_claim",
  exp_claim: "/api/p/v1/katharsis/exp_claim",
  upgrade: "/api/p/v1/katharsis/upgrade",
  og_list: "/api/p/v1/katharsis_og",
  og_reward_claim: "/api/p/v1/katharsis_og/reward_claim",
};

export const API_COMM = {
  //获取签名
  user_sign: "/api/core/v1/upload_sign?platform=web&mime_type=image",
  //获取nonce
  user_nonce: "/api/auth/v1/nonce",
  //发送验证码
  user_sms: "/api/auth/v1/sms",
  //登录
  user_login: "/api/auth/v1/login",
  //登出
  user_logout: "/api/auth/v1/logout",
  // 埋点
  empty: "/api/stat/v1/empty",
  //事件埋点上报
  event_tracks: "/api/stat/v1/event_tracks",
  //个人中心详情
  user_v1: "api/auth/v1/users/{path_user_id}",
  // user_v1: (path_user_id) => `/api/auth/v1/users/${path_user_id}`,
};

/**角色技能天赋向导介绍页 */
export const GUIDE_ROLE = {
  /**获取所有角色 */
  get_all_role: "/api/y/v1/free_roles",
};

/**徽章墙 */
export const BADGE_WALL = {
  /**获取成就徽章墙列表 */
  get_badge_data_list: "/api/p/v1/achievement_medals",
  /**成就奖励领取 */
  get_badge_reward: (id, token_id) => {
    return `/api/p/v1/achievements/${id}/claim?token_id=${token_id}`;
  },
  /**获取成就列表 */
  get_achievement_list: "/api/p/v1/achievements",
  /**获取排行榜 */
  get_achievement_ranking: "/api/p/v1/achievements/ranking",
};

/**语言包 */
export const LANGUAGE_PACK = {
  get_all_language:
    process.env.NODE_ENV !== "production"
      ? "https://yuliverse-beta.s3.amazonaws.com/cfg/app_language_version_test.json"
      : "https://www.yuliverse.com/cfg/app_language_version.json",
};

/**数码港 */
export const CYBER_PROT = {
  getTicketList: "/api/p/v1/activity/food_coupons",
  getUsedTicketList: "/api/p/v1/activity/food_coupon_records",
  postMergeTicket: "/api/p/v1/activity/food_coupons",
  postUseTicket: (id) => {
    return `/api/p/v1/activity/food_coupons/${id}/clip`;
  },
};

/** APP端接口*/
export const APP_GEN_API = {
  getShopRank: "/api/p/v1/market/top_buyers",
};

/** 限时活动*/
export const YuliActivityOther = {
  getPasscardlist: "/api/p/v1/art_airdrop/passcard",
};

export const YuliStaking = {
  getUserProps: "/api/p/v1/u/props",
  getWallet: "/api/p/v1/wallet",
  getYuliList: "/api/p/v1/user/roles",
  postYog2StakingRecord: "/api/p/v2/yog2_staking/records",
  getYog2StakingRecord: "/api/p/v2/yog2_staking/records",
  postYog2StakingRedeem: (id) => {
    `/api/p/v2/yog2_staking/records/${id}/redeem`;
  },
  postYog2StakingRenew: (id) => {
    `/api/p/v2/yog2_staking/records/${id}/renew`;
  },
};
